import { useMemo } from 'react';

const noop = () => {};

export const useProjectCostOverridesData = () => {
  return useMemo(
    () => ({
      loading: false,
      projectRates: [],
      projectRateCount: 0,
      hasMore: false,
      loadingMore: false,
      loadMore: noop
    }),
    []
  );
};

export default useProjectCostOverridesData;
